export default "/vendor/Textile.b7ce1e8b93dfd64f561a4092fe5eb74f.ttf";